import { Container } from './styles'
import ClaimHandlingTable from './ClaimHandlingTable'

const HealthClaimPage = () => {
  return (
    <Container>
      <ClaimHandlingTable />
    </Container>
  )
}

export default HealthClaimPage
